import { CoreDataSecurityMonitorsByApplicationName } from './name';
import { createGetAsyncSlice } from '@sonar-software/xuder';
import { getDataSecurityMonitorsByApplication } from '@api/data-security';

export const getCoreDataSecurityMonitorsByApplicationSlice = createGetAsyncSlice({
	name: CoreDataSecurityMonitorsByApplicationName,
	receive: true,
	request: true,
	requestHandler: getDataSecurityMonitorsByApplication,
	retainDataOnRequest: true
});
